import {DevilsCrossRoad} from "../DevilsCrossRoad";
import {DevilsCrossRoadGameAssets} from "../DevilsCrossRoadGameAssets";
import {BitmapCountUp} from "@nolimitcity/slot-game/bin/component/BitmapCountUp";
import {gsap, TimelineLite} from "gsap";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {DevilsCrossRoadSound} from "../sound/DevilsCrossRoadSound";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {BelowStakeWinRestriction} from "../server/BelowStakeWinRestriction";

export class DCRoadWinCap extends PIXI.Container {
    private _wincapSpine: PIXI.spine.Spine;
    private _countUp: BitmapCountUp;
    private _wincapTimesText: BitmapCountUp;
    private _bgOverlay: PIXI.Graphics;
    private _wincapPlayTl: TimelineLite;
    private _fireWorksTl: TimelineLite;

    constructor() {
        super();
        this.init();
        this.onResize();

    }

    private init(): void {
        this._bgOverlay = new PIXI.Graphics();
        this._bgOverlay.visible = false;
        this.addChild(this._bgOverlay);

        this._wincapSpine = new PIXI.spine.Spine(DevilsCrossRoad.assetLoader.getSpineAsset("wincap"));
        this._wincapSpine.visible = false;
        this._wincapSpine.position.set(360, 360);
        this.addChild(this._wincapSpine);


        const style = {
            fontName: DevilsCrossRoadGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 120,
            tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
        };
        this._countUp = new BitmapCountUp(style);
        this._countUp.shrinkSize = true;
        this._countUp.visible = false;
        this._countUp.position.set(360, 150);
        this.addChild(this._countUp);

        this._wincapTimesText = new BitmapCountUp(style);
        this._wincapTimesText.visible = false;
        this._wincapTimesText.position.set(360, 150);
        this._wincapTimesText.alpha = 0;
        this._wincapTimesText.text = "13180X";
        this.addChild(this._wincapTimesText);

    }

    public getCountUpAnimation(from: number, to: number, duration: number): TimelineLite {
        const tl = gsap.timeline();
        tl.add([
            () => {
                this._countUp.maxTextWidth = 580;
                this._countUp.scale.set(1);
                this._countUp.alpha = 1;
                this._countUp.visible = true;
            },
            this._countUp.getCountUpAnimation(from, to, duration, `power1.out`)
        ]);

        return tl;
    }

    public removeCountup(): TimelineLite {
        const tl = gsap.timeline();
        tl.add(() => {
            if (this._countUp.visible) {
                this._countUp.visible = false;
            }
        });
        return tl;
    }

    public showWinCap(): TimelineLite {
        this._wincapPlayTl = new TimelineLite();
        this._fireWorksTl = new TimelineLite({repeat: -1, duration: 3});
        let duration1: number = this._wincapSpine.spineData.findAnimation("wincap1").duration;
        let duration2: number = this._wincapSpine.spineData.findAnimation("wincap2").duration;
        let duration3: number = this._wincapSpine.spineData.findAnimation("wincap3").duration;
        this._fireWorksTl.add(() => {
            DevilsCrossRoadSound.soundPlayer.playTrack({name: DevilsCrossRoadSound.MAX_WIN_FIREWORKS});
        });
        this._wincapPlayTl.add(() => {
            this._bgOverlay.visible = true;
            this._wincapSpine.visible = true;
            this._wincapTimesText.visible = true;
            DevilsCrossRoad.totalWinCountUp.remove();
            DevilsCrossRoad.bigWinCountUp.remove();
            DevilsCrossRoad.bigwinView.playEnding(4);
        }, 0);
        this._wincapPlayTl.add(() => {
            this._wincapSpine.state.setAnimation(0, "wincap1", false);
        });
        this._wincapPlayTl.add(() => {
            this._wincapSpine.state.setAnimation(0, "wincap2", false);
        }, `>${duration1}`);
        this._wincapPlayTl.add(this._fireWorksTl,`${duration1+duration2}`);
        this._wincapPlayTl.add(() => {
            this._wincapSpine.state.setAnimation(0, "wincap3", true);
            DevilsCrossRoadSound.soundPlayer.playTrack({name: DevilsCrossRoadSound.MAX_WIN_LOOP, repeat: Number.MAX_VALUE });
        },`${duration1+duration2}`);

        this._wincapPlayTl.add(()=>{this.getCountUpAnimation(0, DevilsCrossRoad.model.gameData.accumulatedRoundWin, duration1 + duration2-0.35)}, 0.3);

        this._wincapPlayTl.to(this, {duration: duration1+duration2});
        this._wincapPlayTl.add(this.removeCountup(), ">1");
        this._wincapPlayTl.to(this._wincapTimesText, {duration: 0.2, alpha: 1}, ">");
        this._wincapPlayTl.add(()=>{
            DevilsCrossRoad.keypadPlugin.show();
            DevilsCrossRoad.keypadPlugin.setWin(DevilsCrossRoad.model.gameData.accumulatedRoundWin, true, BelowStakeWinRestriction.isWinBelowStake())
        },"<");

        return this._wincapPlayTl;
    }

    public hideWinCap(): TimelineLite {
        let hideTl: TimelineLite = new TimelineLite();
        if (this._fireWorksTl) {
            DevilsCrossRoadSound.soundPlayer.stopTrack(DevilsCrossRoadSound.MAX_WIN_FIREWORKS);
            this._fireWorksTl.kill();
        }
        if (this._wincapPlayTl) {
            this._wincapPlayTl.kill();
        }
        hideTl.add(() => {
            this._bgOverlay.visible = false;
            this._wincapTimesText.visible = false;
            this._wincapTimesText.alpha = 0;
            this._wincapSpine.visible = false;
            this.wincapSpineReset();

            DevilsCrossRoadSound.soundPlayer.playTrack({name:DevilsCrossRoadSound.MAX_WIN_END});
            if (DevilsCrossRoadSound.soundPlayer.fetchSoundPlayer(DevilsCrossRoadSound.MAX_WIN_LOOP)?.isPlaying) {
                DevilsCrossRoadSound.soundPlayer.stopTrack(DevilsCrossRoadSound.MAX_WIN_LOOP);
            }
            DevilsCrossRoadSound.switchMusic({name: DevilsCrossRoadSound.MAIN_GAME_MUSIC});
            DevilsCrossRoadSound.fadeMusic(1,0.1);
        });
        return hideTl;
    }

    public onResize(): void {
        if (this._bgOverlay) {
            this._bgOverlay.clear();
            this._bgOverlay.beginFill(0x000000, 1);
            this._bgOverlay.drawRect(NolimitApplication.screenBounds.left, NolimitApplication.screenBounds.top, NolimitApplication.screenBounds.width, NolimitApplication.screenBounds.height);
            this._bgOverlay.endFill();
        }
    }

    private wincapSpineReset(): void {
        this._wincapSpine.state.clearTracks();
        this._wincapSpine.skeleton.setToSetupPose();
        this._wincapSpine.skeleton.setSlotsToSetupPose();
    }
}